/**
 * Parse pasted text or CSV content into unique ITS number strings.
 * Accepts one-per-line, comma/semicolon/whitespace separated, optional header row.
 */
export function parseHofItsList(raw: string): string[] {
  const text = raw.replace(/^\uFEFF/, "").trim();
  if (!text) return [];

  const lines = text.split(/\r?\n/);
  const tokens: string[] = [];

  for (let i = 0; i < lines.length; i++) {
    const line = lines[i].trim();
    if (!line) continue;

    const cells = line.split(/[,;\t]+/).map((c) => c.trim().replace(/^["']|["']$/g, ""));
    // Skip a header row like "ITS_ID" / "ITS" / "hofItsNo"
    if (
      i === 0 &&
      cells.length > 0 &&
      cells.every((c) => !/^\d{5,}$/.test(c) && /its|hof|id|name/i.test(c))
    ) {
      continue;
    }

    for (const cell of cells) {
      if (!cell) continue;
      // Prefer a pure digit token; otherwise extract first long digit run.
      if (/^\d{5,}$/.test(cell)) {
        tokens.push(cell);
        continue;
      }
      const match = cell.match(/\d{5,}/);
      if (match) tokens.push(match[0]);
    }
  }

  // Also split leftover whitespace-only pastes without newlines (handled above per line).
  if (tokens.length === 0) {
    for (const part of text.split(/[\s,;]+/)) {
      const t = part.trim();
      if (/^\d{5,}$/.test(t)) tokens.push(t);
    }
  }

  const seen = new Set<string>();
  const unique: string[] = [];
  for (const its of tokens) {
    if (seen.has(its)) continue;
    seen.add(its);
    unique.push(its);
  }
  return unique;
}
